import environment from '../env-config';

export const LOCAL_IMPERSONATION_STORAGE_KEY = 'localImpersonationUserId';
export const LOCAL_IMPERSONATION_EVENT = 'local-impersonation-change';
export const LOCAL_IMPERSONATION_ADMIN_ROUTE = '/solucky';

const LOOPBACK_HOSTS = new Set(['localhost', '127.0.0.1', '::1']);

const normalizeHost = (value) => String(value || '').trim().replace(/^\[|\]$/g, '').toLowerCase();

export const isLocalImpersonationUiEnabled = () => {
    if (typeof window === 'undefined') return false;
    return LOOPBACK_HOSTS.has(normalizeHost(window.location.hostname));
};

export const getLocalImpersonationUserId = () => {
    if (typeof window === 'undefined' || !isLocalImpersonationUiEnabled()) return null;
    const value = window.localStorage.getItem(LOCAL_IMPERSONATION_STORAGE_KEY);
    return value && value.trim() ? value.trim() : null;
};

export const setLocalImpersonationUserId = (userId) => {
    if (typeof window === 'undefined') return;

    if (userId && String(userId).trim()) {
        window.localStorage.setItem(LOCAL_IMPERSONATION_STORAGE_KEY, String(userId).trim());
    } else {
        window.localStorage.removeItem(LOCAL_IMPERSONATION_STORAGE_KEY);
    }

    window.dispatchEvent(
        new CustomEvent(LOCAL_IMPERSONATION_EVENT, {
            detail: {
                userId: userId ? String(userId).trim() : null
            }
        })
    );
};

export const clearLocalImpersonationUserId = () => {
    setLocalImpersonationUserId(null);
};

export const stopLocalImpersonationAndOpenAdmin = () => {
    clearLocalImpersonationUserId();

    if (typeof window !== 'undefined') {
        window.location.assign(LOCAL_IMPERSONATION_ADMIN_ROUTE);
    }
};

export const getApiBaseUrl = () => {
    return String(environment.REACT_BACKEND_URL || '').replace(/\/graphql\/?$/, '');
};
